import { useQuery } from "@tanstack/react-query";
import { getInvoices } from "../../Requests";
import { useAppSelector } from "..";

function useInvoiceQuery(municipalKey: string, ownerId: string) {
  const access_token = useAppSelector(state => state.auth.user?.access_token) ?? '';
  return useQuery({
    queryKey: ["invoice", municipalKey + "_" + ownerId],
    queryFn: () => getInvoices(municipalKey, ownerId, access_token),
    enabled: !!access_token,
  });
}

export { useInvoiceQuery };
